/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { defineStore } from 'pinia';

import {
  AutocompleteRepository,
  WalletServiceResponse,
} from '@/repositories/generated';

type WalletServiceAutocompleteStoreState = {
  walletServices: WalletServiceResponse[];
  bankPay: boolean;
  issuerId: string | undefined;
};

export const useWalletServiceAutocompleteStore = defineStore('walletServiceAutocomplete', {
  state: (): WalletServiceAutocompleteStoreState => ({
    walletServices: [],
    bankPay: false,
    issuerId: undefined,
  }),
  actions: {
    async getWalletServices(bankPay = false, issuerId?: string) {
      // 一度取得したらキャッシュから取得
      if (this.walletServices.length && this.bankPay === bankPay) {
        return this.walletServices;
      }

      const res = await AutocompleteRepository.searchWalletService({
        term: undefined,
        bankPay,
        issuerId,
      });
      this.walletServices = res;
      return res;
    },
    async getWalletServiceIds(bankPay = false) {
      const walletServiceIds = (await this.getWalletServices(bankPay)).map((value) => value.id);
      return walletServiceIds;
    },
  },
});
